var DEBUG = (typeof localStorage !== 'undefined' && localStorage.getItem('isOfflineModuleDebug') === 'true') || false;
function switchDebug(debug) {
    if (typeof localStorage === 'undefined') {
        return;
    }
    localStorage.setItem('isOfflineModuleDebug', String(debug));
    DEBUG = debug;
}
export { DEBUG, switchDebug };
//# sourceMappingURL=Constant.js.map